<template>
    <div class="main-block request-management">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h2 class="">{{ $t('integration.integrations') }}</h2>
            <router-link :to="{ name: 'IntegrationCreate'}"
                            class="btn btn-primary">
                <b-icon icon="plus" class="icon-style"></b-icon>
                {{ $t('integration.add_new') }}
            </router-link>
        </div>
        <div class="scrollable-block">
            <div>
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template v-slot:cell(services)="{ item }">
                        <div class="d-flex align-items-center integration-logo">
                            <img :src="getServiceLogo(item.services)" :alt="item.services" height="30px" class="mr-2" />
                        </div>
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <b-button variant="light" @click="openModal(item.id)">
                            <b-icon variant="danger" icon="trash" class="icon-style"></b-icon>
                        </b-button>
                        <!-- Edit Button -->
                        <b-button variant="light"
                            @click="$router.push({ name: 'IntegrationUpdate', params: { id: item.id } })">
                            <b-icon variant="primary" icon="pencil-square" class="icon-style"></b-icon>
                        </b-button>

                        <b-button variant="light" @click="$router.push({name: 'IntegrationUsers', params: {integration_id: item.id}})">
                            <b-icon variant="info" icon="gear-fill" class="icon-style"></b-icon>
                        </b-button>


                    </template>
                    <template #cell(data)="{ item }">
                        <div>
                            <div v-for="(value, key) in item.data" :key="key"
                                class="d-flex justify-content-between align-items-center">
                                <span>
                                    <strong>{{ $t(`title.${key}`) }}:</strong>

                                    <span
                                        v-if="key === 'google_service_account_credentials_json' && value && visibleFields[item.id]?.[key]">
                                        <!-- <a :href="value" target="_blank" class="text-primary"> -->
                                        {{ value }}
                                        <!-- </a> -->
                                    </span>

                                    <span v-if="!visibleFields[item.id]?.[key]"></span>
                                    <span v-else v-b-popover.hover.top="value">
                                        {{ key !== 'google_service_account_credentials_json' ? (value.length > 100 ?
                                            value.substring(0, 100) + '...' : value) : '' }}
                                        <b-button variant="light" @click="copyValue(value, item.id, key)" v-if="value">
                                            <b-icon variant="primary" icon="files" class="icon-style"></b-icon>
                                        </b-button>
                                    </span>
                                </span>

                                <!-- Visibility toggle button -->
                                <button @click="toggleVisibility(item.id, key)" class="btn btn-link p-0">
                                    <i :class="visibleFields[item.id]?.[key] ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                </button>
                            </div>
                        </div>
                    </template>


                    <template v-slot:cell(sync_manually)="{ item }">
                        <b-button variant="primary" class="rounded-circle" @click="syncManually(item.id)">
                            <b-icon icon="cloud-upload" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                    <template v-slot:cell(is_active)="{ item }">
                        <b-button type="button" variant="light" @click="toggleStatus(item.id, item.is_active)">
                            <b-icon :variant="item.is_active ? 'success' : 'secondary'"
                                :icon="item.is_active ? 'toggle-on' : 'toggle-off'" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                </crud-table>
                <b-modal
                    v-model="showDeleteModal"
                    :title="$t('integration.delete_modal_title')"
                    @ok="handleDelete"
                    ok-variant="danger"
                    >
                    {{ $t('integration.delete_modal_message') }}
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
// import { Modal } from "bootstrap"; // Ensure this import is available in your project
import CrudTable from "@/components/CrudTable.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null
};

const COLUMN_STATE = (self) => [
    { key: 'actions', label: self.$t('integration.actions') },
    { key: 'services', label: self.$t('integration.services'), sortable: true },
    { key: 'name', label: self.$t('integration.name'), sortable: true },
    // { key: 'sync_status', label: self.$t('integration.sync_status'), sortable: true },
    // { key: 'failure_reason', label: self.$t('integration.failure_reason'), sortable: true },
    // { key: 'sync_manually', label: self.$t('integration.sync_manually') },
    // { key: 'updated_at', label: self.$t('integration.sync_date_time') },
    { key: 'is_active', label: self.$t('integration.status'), sortable: true },
];

export default {
    name: 'IntegratioIndex',
    components: {
        CrudTable
    },
    data() {
        return {
            operation: '',
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0,
            },
            listUrl: '/admin/integrations',
            filters: { ...FILTER_FORM },
            showPopup: false,
            modalInstance: null, // Declare modalInstance here
            visibleFields: {},
            selectedItemId: null,
            showDeleteModal: false,
        };
    },
    methods: {
        getServiceLogo(service) {
            const logos = {
                "G-suit": require("@/assets/google.png"),
                "Salesforce": require("@/assets/salesforce.png"),
                "ZOHO": require("@/assets/zoho.png"),
                "Monday": require("@/assets/monday.png"),
                "Microsoft 365": require("@/assets/office365.png"),
                "SAP": require('@/assets/sap.png'),
                "booking.com": require('@/assets/bookingcom.png'),
            };
            return logos[service] || require("@/assets/integration.png");
        },
        navigateToService(item) {
            if (item.services === "G-suit") {
                this.$router.push({ name: "G-suitUsers", params: { id: item.id } });
            } else if (item.services === "Microsoft 365") {
                this.$router.push({ name: "Office365Users", params: { id: item.id } });
            } else if (item.services === "Salesforce") {
                if (item.data.product_service === "CRM") {
                    this.$router.push({ name: "SalesforceCrmUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Education Cloud") {
                    this.$router.push({ name: "SalesforceEducationCloudUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Analytics") {
                    this.$router.push({ name: "SalesforceAnalyticsUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Net Zero Cloud") {
                    this.$router.push({ name: "SalesforceNetZeroCloudUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Financial Services Cloud") {
                    this.$router.push({ name: "SalesforceFinancialServicesCloudUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Communications Cloud") {
                    this.$router.push({ name: "SalesforceCommunicationsCloudUsers", params: { id: item.id } });
                }
            } else if (item.services === "Monday") {
                this.$router.push({ name: "MondayCRMContacts", params: { id: item.id } });
            } else if (item.services === "ZOHO") {
                this.$router.push({ name: "ZohoCrmUsers", params: { id: item.id } });
            } else {
                this.showToast(this.$t("title.error"), this.$t("title.serviceNotSupported"));
            }
        },
        openModal(id) {
            this.selectedItemId = id;
            this.showDeleteModal = true;
        },
        closeModal() {
            if (this.modalInstance) {
                this.modalInstance.hide();
            }
        },
        async handleDelete() {
            if (!this.selectedItemId) return;

            try {
                await request({
                method: 'delete',
                url: `/admin/integrations/${this.selectedItemId}`
                });

                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                console.error('Error deleting product:', error);
            } finally {
                this.showDeleteModal = false;
                this.selectedItemId = null;
            }
        },
        copyValue(value, id, key) {
            console.log(id,key,value);
            if (!value) return;

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(value)
                    .then(() => {
                        this.showToast(this.$t("title.TextCopied"), this.$t("title.TextCopySuccessfully"), 1);
                    })
                    .catch((error) => {
                        console.error("Clipboard API failed:", error);
                    });
            } else {
                // Fallback for older browsers
                let textarea = document.createElement("textarea");
                textarea.value = value;
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    document.execCommand("copy");
                    this.showToast(this.$t("title.TextCopied"), this.$t("title.TextCopySuccessfully"), 1);
                } catch (error) {
                    console.error("Fallback copy failed:", error);
                }
                document.body.removeChild(textarea);
            }
        },
        toggleVisibility(id, key) {
            if (!this.visibleFields[id]) {
                this.$set(this.visibleFields, id, {});
            }
            this.$set(this.visibleFields[id], key, !this.visibleFields[id][key]);
        },
        async syncManually(id) {
            try {
                await request({
                    method: 'post',
                    url: `/admin/integrations/${id}/sync`,
                });
                this.checkSyncStatus(id);

                this.showToast(this.$t("title.syncStarted"), this.$t("title.syncInitiated"), 1);
                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                console.error("Sync failed:", error);
                this.showToast(this.$t("title.error"), this.$t("title.syncFailed"), 0);
            }
        },

        async toggleStatus(id, is_active) {
            console.log(is_active);
            try {
                await request({
                    method: 'get',
                    url: `/admin/integrations/change-status/${id}`,
                });
                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },
        handleFilter() {
            this.$refs['application-table'].handleFilter(this.filters);
        },
        resetFilter() {
            this.filters = { ...FILTER_FORM };
        },
        showToast(title, msg, status) {
            const h = this.$createElement;
            const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [msg]);
            const vNodesTitle = h('div', { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [h('strong', { class: 'mr-2' }, title)]
            );

            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: status === 1 ? 'primary' : 'danger',
            });
        },
        async checkSyncStatus(id) {
            let response = await request({ method: 'get', url: `/admin/integrations/${id}/status` });
            // Ensure response and response.data exist before accessing status
            if (response && response.status) {
                if (response.status === 'completed') {
                    this.showToast(this.$t("title.syncCompleted"), this.$t("title.syncFinished"), 1);
                    this.$refs['application-table'].refreshTableData();
                } else {
                    setTimeout(() => this.checkSyncStatus(id), 5000);
                }
            } else {
                console.warn("Invalid API response structure:", response);
            }
        }
    },
    computed: {
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
